import React from "react";

const YEARLY_DISCOUNT = "YearlyDiscount"

export default class TncGeneral extends React.Component{
  render(){
    const couponsForFourthTnC = ["REIP20"]
    const eofyTnC = ["EOFY 2019 Prepay"]
    return (
      <div className="row padding-10">
        <div className="col-sm-12 terms-cond">
          <div>
            {
              this.props.conditionalTC === true &&
              <span className="text-uppercase">{this.props.headline} - </span>
            }
            TERMS & CONDITIONS
          </div>
          <ul className="list-padding">
            {/*<!-- FIRST DOT POINT -->*/}
            <li>This is a binding contract with RP Data Pty Ltd t/a Cotality . It combines the commercial terms on this webpage together with our <a className="terms-link" href="https://www.cotality.com/au/legal/terms-conditions" target="_blank" rel="noopener noreferrer">Cotality Licence Agreement</a> and <a className="terms-link" href="https://www.cotality.com/au/legal/privacy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>;</li>
            {/*<!-- ========================================================================================================================= -->*/}

            {/*<!-- SECOND DOT POINT -->*/}
            {
              (!this.props.isReport &&
                (!this.props.couponEntity ||
                  (this.props.couponEntity &&
                     (this.props.couponEntity.discountServiceType !== YEARLY_DISCOUNT ||
                       (this.props.couponEntity.discountServiceType === YEARLY_DISCOUNT  && this.props.yearlyDiscount === null)))
                )
              ) &&

              <li>Your minimum contract period (aka Initial Period) is {this.props.totalMonths} months; after this time you will continue to have access to our system at your contracted monthly price;</li>
            }
            {
              this.props.couponEntity && this.props.couponEntity.discountServiceType === YEARLY_DISCOUNT  && this.props.yearlyDiscount > 0 &&
              <li>Your minimum contract period (aka Initial Period) is 12 months; after this time your contract will auto-renew and you will have access to our system at ${this.props.totalPerMonth.toFixed(2)}AUD per month.</li>
            }
            {
              (this.props.isReport) &&
              <li>Your minimum contract period (aka Initial Period) is {this.props.totalMonths} months; after this time you will continue to receive reports at your contracted monthly price;</li>
            }
            {/*<!-- ========================================================================================================================= -->*/}

            {/*<!-- THIRD DOT POINT -->*/}
            {
              !this.props.isReport &&
              <li>To discontinue your access at the end of the Initial Period, you need to give us {this.props.totalDays} days’ advance notice. After the Initial Period we will also need {this.props.totalDays} days advance notice to terminate your access.</li>
            }
            {
              this.props.isReport &&
              <li>
                To discontinue your subscription at the end of the Initial Period, you need to give us {this.props.totalDays} days’ advance written notice. After the Initial Period we will also need {this.props.totalDays} days advance written notice to terminate your subscription.
              </li>
            }
            {/*<!-- ========================================================================================================================= -->*/}

            {/*<!-- FOURTH DOT POINT -->*/}
            {
              this.props.couponEntity && this.props.couponEntity.code && couponsForFourthTnC.indexOf(this.props.couponEntity.code) !== -1 &&
              <li>
                This offer only applies to REIP members who, are a) new Cotality customers, or b) Cotality customers subscribing to a new product.
              </li>
            }
            {this.props.isRPP && (
              <li>
                You acknowledge and agree that where you have elected a package containing RP
                Inside, you must have an{' '}
                <a
                  className='terms-link'
                  href='https://www.cotality.com/au/products/rp-data#pricing'
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  eligible CRM or PropTech platform
                </a>{' '}
                in order to receive an RP Inside integration.
              </li>
            )}
            {/*<!-- ========================================================================================================================= -->*/}

            {/*<!-- EOFY DOT POINT -->*/}
            {
              this.props.couponEntity && this.props.couponEntity.code && eofyTnC.indexOf(this.props.couponEntity.code) !== -1 &&
              <li>
                Second year billing amount and frequency: ${this.props.totalPerMonth.toFixed(2)}AUD per month
              </li>
            }
            {/*<!-- ========================================================================================================================= -->*/}
          </ul>
        </div>
      </div>
    )
  }
}
